import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OperatorsSettingsComponent} from './operators-settings.component';
import {OperatorsDialogComponent} from './operators-dialog/operators-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {ColumnsFilterModule} from '../../../components/columns-filter/columns-filter.module';
import {FlexModule} from '@angular/flex-layout';
import {MatTableModule} from '@angular/material/table';
import {DialogModule} from '../../../components/dialog/dialog.module';
import {MaterialModule} from '../../../material.module';
import {LayoutModule} from '../../../components/layout/layout.module';
import {ArmTableModule} from '../../../components/arm-table/arm-table.module';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import { OperatorsSearchComponent } from './operators-search/operators-search.component';
import {InfraModule} from 'ac-infra';
import {SearchModule} from '../../../components/search/search.module';
import {ChangePasswordDialogComponent} from './change-password-dialog/change-password-dialog.component';

@NgModule({
  declarations: [
    OperatorsSettingsComponent,
    OperatorsDialogComponent,
    OperatorsSearchComponent,
    ChangePasswordDialogComponent
  ],
    imports: [
        CommonModule,
        MatIconModule,
        MatFormFieldModule,
        MatButtonModule,
        MatTooltipModule,
        FormsModule,
        MatInputModule,
        MatSelectModule,
        ColumnsFilterModule,
        FlexModule,
        MatTableModule,
        DialogModule,
        ReactiveFormsModule,
        MaterialModule,
        LayoutModule,
        ArmTableModule,
        ActionBarModule,
        InfraModule,
        SearchModule
    ]
})
export class OperatorsSettingsModule { }
